export function changeTagName(element: HTMLElement, newTagName: string) {
  const newElement = document.createElement(newTagName);
  Array.from(element.attributes).forEach((attr) => {
    newElement.setAttribute(attr.name, attr.value);
  });

  while (element.firstChild) {
    newElement.appendChild(element.firstChild);
  }

  element.parentNode?.replaceChild(newElement, element);
  return newElement;
}
